import styled from 'styled-components'

import { EyebrowCondensed } from 'components/Typography'
import theme from 'styles/theme'
import colors from 'styles/colors'
import { transitions } from 'polished'

export const Wrapper = styled.div`
  display: flex;
`

export const ServiceSelector = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
  grid-gap: ${theme.space[8]};
  margin: ${theme.space[4]} ${theme.space[4]} 0px ${theme.space[4]};
`

export const ServiceItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
  max-width: 100px;
  cursor: pointer;
  overflow-wrap: anywhere;

  ${theme.mediaQueries.small} {
    min-width: 60px;
    :not(:last-child) {
      margin-right: ${theme.space[11]};
    }
  }
`

export const ServiceItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px; // recommended tap area for mobile
  margin-bottom: 5px;
  border-width: 1px;
  border-style: solid;
  border-color: ${(props) =>
    props.selected ? colors.alabaster : 'transparent'};
  border-radius: 20px;
  ${transitions('all ease 0.1s')};

  ${ServiceItem}:hover & {
    border-color: ${colors.alabaster};
  }
`

export const ServiceItemTitle = styled(EyebrowCondensed)`
  color: ${(props) => (props.selected ? colors.sagedark : colors.sagemedium)};
  text-align: center;
  ${transitions('all ease 0.1s')};
`
